<!--
 * @Author: yeqing
 * @Date: 2021-11-24 10:19:44
 * @LastEditTime: 2022-05-13 15:34:18
 * @LastEditors: yeqing
 * @Description: 专精能力组件
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\smEvaluation\components\specializationModel.vue
-->
<template>
  <div class="specializationModel">
    <a-form>
      <a-form-item
        label="1、企业是否专注核心业务，具有较高专业化生产和协作配套的能力，某一产品在细分市场处于领先地位"
      >
        <a-radio-group name="radioGroup" v-model="specialization.q421">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="2、主导产品销售收入是否占本企业销售收入的50%以上">
        <a-radio-group name="radioGroup" v-model="specialization.q422">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="3、企业管理体系及品牌情况：" class="block">
        <a-checkbox-group
          name="checkboxgroup"
          :value="awardList"
          :options="awardOptions"
          @change="onChangeAward"
        ></a-checkbox-group>
      </a-form-item>
      <a-form-item
        label="4、企业是否获得技术、质量、工程、环保、安全等资质或资格认定"
      >
        <a-radio-group name="radioGroup" v-model="specialization.q424">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <div style="text-align: center; margin-top: 40px;">
        <a-button class="primary-btn pre-btn" @click="handlePre"
          >上一步</a-button
        >
        <a-button class="primary-btn" @click="handleNext">下一步</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
export default {
  name: "specializationModel",
  data() {
    return {
      specialization: {
        q421: "",
        q422: "",
        q423: "",
        q424: "",
      },
      awardOptions: [
        "企业建立精细高效的管理制度和流程，产品质量精良，产品品质在业内得到公认，产品执行标准达到国内或国际先进水平",
        "产品通过发达国家和地区的产品认证（国际标准协会行业认证）",
        "主导产品属于关键领域“补短板”、关键核心技术攻关、填补国内空白（国际空白）",
        "主导产品暂未获得相关认证",
      ],
      awardList: [],
    };
  },
  methods: {

    onChangeAward(e){
      if(e.length > 1 && e.findIndex(item=>item == '主导产品暂未获得相关认证') !=-1){
         this.$message.warn("您的多选项有冲突，请重新选择。");
         return
      }
      this.awardList = e
    },

    // 下一步
    handleNext(e) {
      e.preventDefault();
      this.specialization.q423 = this.awardList.join(",");
      this.$emit("changeTabKey", {
        name: "specialization",
        key: 3,
        data: this.specialization,
      });
    },
    // 上一步
    handlePre(e) {
      e.preventDefault();
      this.$emit("changeTabKey", {
        name: "specialization",
        key: 1,
        data: this.specialization,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.specializationModel {
  margin-top: 30px;
}
</style>
